import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  Photo,
  UpdateVideoPayload,
  UpdateVideoResponse,
  Video,
  VideoPayload,
} from '../../common/models'

export const createVideo = (festivalEditionId: string, data: VideoPayload) =>
  http.post<Video>(`/operations/festival-edition/${festivalEditionId}/video`, {
    ...data,
  })

export const getVideos = (
  festivalEditionId: string,
  params?: PaginationParams,
) =>
  http.get<Pagination<Video>>(
    `/operations/festival-edition/${festivalEditionId}/video`,
    {
      params,
    },
  )

export const getVideo = (festivalEditionId: string, id: string) =>
  http.get<Video>(
    `/operations/festival-edition/${festivalEditionId}/video/${id}`,
  )

export const deleteVideo = (festivalEditionId: string, id: string) =>
  http.delete(
    `/operations/festival-edition/${festivalEditionId}/video/${id}`,
    {},
  )

export const updateVideo = (
  id: string,
  festivalEditionId: string,
  data: UpdateVideoPayload,
) =>
  http.put<UpdateVideoResponse>(
    `/operations/festival-edition/${festivalEditionId}/video/${id}`,
    { ...data },
  )

export const unpublishVideo = (festivalEditionId: string, ids: string[]) =>
  http.put<UpdateVideoResponse[]>(
    `/operations/festival-edition/${festivalEditionId}/video/unpublish`,
    { ids },
  )

export const publishVideo = (festivalEditionId: string, ids: string[]) =>
  http.put<UpdateVideoResponse[]>(
    `/operations/festival-edition/${festivalEditionId}/video/publish`,
    { ids },
  )

export const savePhoto = (festivalEditionId: string, keys: string[]) =>
  http.post<Photo>(
    `/operations/festival-edition/${festivalEditionId}/photo-gallery/save`,
    {
      photoKeys: keys,
    },
  )

export const getPhotos = (
  festivalEditionId: string,
  params?: PaginationParams,
) =>
  http.get<Pagination<Photo>>(
    `/operations/festival-edition/${festivalEditionId}/photo-gallery`,
    {
      params,
    },
  )

export const deletePhoto = (festivalEditionId: string, ids: string[]) =>
  http.delete(
    `/operations/festival-edition/${festivalEditionId}/photo-gallery`,
    {
      data: {
        ids,
      },
    },
  )

export const unpublishPhoto = (festivalEditionId: string, ids: string[]) =>
  http.put<UpdateVideoResponse[]>(
    `/operations/festival-edition/${festivalEditionId}/photo-gallery/unpublish`,
    {
      ids,
    },
  )

export const publishPhoto = (festivalEditionId: string, ids: string[]) =>
  http.put<UpdateVideoResponse[]>(
    `/operations/festival-edition/${festivalEditionId}/photo-gallery/publish`,
    {
      ids,
    },
  )
